export class GetOffers {
    constructor() {
        this.handle = async (requestBody) => {
            try {
                const response = await fetch('https://388b0cc0-6fcf-4f9e-9b24-6ea61816d622.mock.pstmn.io/availability', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                return data.offers;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
